@if ((!creatorBriefingMode() || isAnalyticsPlannedMode()) && kpiGoalsTableRows().length > 0) {
  <div class="flex flex-col">
    <h3 class="text-base" [class.pl-6]="!isAnalyticsPlannedMode()">
      {{ 'pages.campaignDetails.ctaAnalytics.details.kpiGoals.title' | translate }}
    </h3>

    <div class="kpi-goals-table" [class.kpi-goals-table--planned]="isAnalyticsPlannedMode()">
      <app-datatable
        [rowData]="kpiGoalsTableRows()"
        [columns]="isAnalyticsPlannedMode() ? plannedModeTableColumns : kpiGoalsTableColumns"
        [configurationInput]="kpiGoalsDatatableConfig()"
        [customColumnDef]="isAnalyticsPlannedMode() ? plannedModeCustomColumns() : kpiGoalsCustomColumns()"
        [total]="kpiGoalsTableRows().length"
        [isInitialDataLoaded]="true"
        [loadingData]="false"
      />
    </div>
  </div>
}

<ng-template #kpiGoalsStatusColumn let-row="row">
  @if (row.statusBadge === null) {
    <span class="text-sm text-shikenso-purple-base-60">-</span>
  } @else {
    <app-status-badge colorScheme="kpiGoals" [status]="row.statusBadge" />
  }
</ng-template>

<ng-template #kpiGoalsKpiColumn let-row="row">
  <span>{{ row.kpi }}</span>
</ng-template>

<ng-template #kpiGoalsCurrentColumn let-row="row">
  <span>{{ row.current }}</span>
</ng-template>

<ng-template #kpiGoalsExpectedColumn let-row="row">
  <span>{{ row.expected }}</span>
</ng-template>
